import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Modal
} from "@mui/material";
import "./UpdateMfidForm.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import { useNavigate, useParams } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg";
import search from "../../../../assests/search.svg";
import Table from "react-bootstrap/Table";

const UpdateMfidFormComponent = (props) => {
  const [selectedVendor, setSelectedVendor] = useState({ id: "", name: "" });
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (props.mfidDetailsData) {
      props.setFormData({
        zohoItemTypeId: props.mfidDetailsData.zohoItemTypeId || "",
        vendorPrice: props.mfidDetailsData.vendorPrice || "",
        mrp: props.mfidDetailsData.mrp || "",
        offerPrice: props.mfidDetailsData.offerPrice || "",
        manufacturerId: props.mfidDetailsData.manufacturerId || "",
        vendorName: props.mfidDetailsData.manufacturerName || "",
        mvId: id,
      });

      setSelectedVendor({
        id: props.mfidDetailsData.manufacturerId || "",
        name: props.mfidDetailsData.manufacturerName || "",
      });
    }
  }, [props.mfidDetailsData, id, props.setFormData]);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const goback = () => navigate(-1);
  const handleCreateNewVendor = () => navigate("/home/configuration/productsvariantdetails/createnewvendor");

  const handleVendorSelect = (vendor) => {
    setSelectedVendor({ id: vendor.id, name: vendor.name });
    props.setFormData((prevState) => ({
      ...prevState,
      manufacturerId: vendor.id,
      vendorName: vendor.name,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    props.setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePurchaseTypeChange = (event) => {
    const { value } = event.target;
    const selectedType = props.dropdownData.find((item) => item.id === value);
    props.setFormData((prevState) => ({
      ...prevState,
      zohoItemTypeId: value,
      zohoItemTypeName: selectedType ? selectedType.name : "",
    }));
  };

  const handleSave = () => {
    props.handleUpdateMfidApi(props.formData);
  };

  return (
    <div className="update-mfid-container">
      <div className="update-mfid-sidebar">
        <Sidebar />
      </div>

      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="update-mfid-content">
          <div className="update-mfid-header">
            <img
              onClick={goback}
              className="update-mfid-back-button"
              src={leftArrow}
              alt="Back"
            />
            <h2 className="update-mfid-title">Edit MFID</h2>
          </div>

          <div className="update-mfid-form-wrapper">
            <Box className="update-mfid-form-box">
              <FormControl fullWidth className="update-mfid-form-control">
                <InputLabel>Purchase Type</InputLabel>
                <Select
                  name="purchaseType"
                  value={props.formData.zohoItemTypeId}
                  onChange={handlePurchaseTypeChange}
                  label="Purchase Type"
                >
                  <MenuItem value="">Select Purchase Type</MenuItem>
                  {props.dropdownData &&
                    props.dropdownData.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="vendor-search-modal"
                className="update-mfid-modal-overlay"
              >
                <div className="update-mfid-modal-container">
                  <div className="update-mfid-modal-content">
                    <div className="update-mfid-modal-header">
                      <img
                        onClick={handleClose}
                        className="update-mfid-modal-back-button"
                        src={leftArrow}
                        alt="Back"
                      />
                      <h2 className="update-mfid-modal-title">Search Vendor</h2>
                    </div>
                    
                    <div className="update-mfid-search-section">
                      <div className="update-mfid-search-container">
                        <div className="update-mfid-search-input-container">
                          <input
                            type="search"
                            placeholder="Search by Vendor Name/ID"
                            onChange={(e) => props.handleSearch(e.target.value)}
                            className="update-mfid-search-input"
                          />
                          <img
                            className="update-mfid-search-icon"
                            src={search}
                            alt="Search"
                          />
                        </div>
                        <Button
                          variant="contained"
                          className="update-mfid-create-vendor-button"
                          onClick={handleCreateNewVendor}
                        >
                          Create New Vendor
                        </Button>
                      </div>

                      <div className="update-mfid-table-container">
                        <Table striped hover className="update-mfid-vendor-table">
                          <thead>
                            <tr>
                              <th className="update-mfid-table-id">ID</th>
                              <th className="update-mfid-table-name">Vendor Name</th>
                              <th className="update-mfid-table-phone">Phone Number</th>
                              <th className="update-mfid-table-email">Email ID</th>
                              <th className="update-mfid-table-select">Select</th>
                            </tr>
                          </thead>

                          <tbody>
                            {props.filteredVendorList && props.filteredVendorList.length > 0 ? (
                              props.filteredVendorList.map((el) => (
                                <tr key={el.id} className="update-mfid-table-row">
                                  <td className="update-mfid-table-cell">{el.id}</td>
                                  <td className="update-mfid-table-cell">{el.name}</td>
                                  <td className="update-mfid-table-cell">{el.phoneNumber}</td>
                                  <td className="update-mfid-table-cell">{el.email}</td>
                                  <td className="update-mfid-table-cell">
                                    <input
                                      id={el.id}
                                      type="radio"
                                      className="update-mfid-vendor-radio"
                                      onChange={() => handleVendorSelect(el)}
                                      checked={selectedVendor.id === el.id}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr className="update-mfid-table-row">
                                <td colSpan="5" className="update-mfid-no-vendors-message">
                                  No vendors found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>

                    <div className="update-mfid-modal-button-group">
                      <Button 
                        variant="outlined" 
                        className="update-mfid-modal-cancel-button" 
                        onClick={handleClose}
                      >
                        Back
                      </Button>
                      <Button 
                        variant="contained" 
                        className="update-mfid-modal-save-button" 
                        onClick={handleClose}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </Modal>

              <Box className="update-mfid-vendor-select-section">
                <TextField
                  fullWidth
                  name="vendorName"
                  value={selectedVendor.name}
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  label="Vendor Name"
                  className="update-mfid-vendor-name-input"
                />
                <Button 
                  variant="outlined" 
                  onClick={handleOpen} 
                  className="update-mfid-select-vendor-button"
                >
                  Select Vendor
                </Button>
              </Box>

              <Box className="update-mfid-price-fields-section">
                <TextField
                  fullWidth
                  name="vendorPrice"
                  value={props.formData.vendorPrice}
                  onChange={handleChange}
                  label="Vendor Price"
                  className="update-mfid-price-input"
                />
                <TextField
                  fullWidth
                  name="mrp"
                  value={props.formData.mrp}
                  onChange={handleChange}
                  label="MRP"
                  className="update-mfid-price-input"
                />
              </Box>

              <TextField
                fullWidth
                name="offerPrice"
                value={props.formData.offerPrice}
                onChange={handleChange}
                label="Selling Price"
                type="number"
                className="update-mfid-price-input"
              />

              <Box className="update-mfid-form-button-group">
                <Button className="update-mfid-cancel-button" onClick={goback}>
                  Cancel
                </Button>
                <Button className="update-mfid-save-button" onClick={handleSave}>
                  Save
                </Button>
              </Box>
            </Box>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateMfidFormComponent;